import React, { useState } from "react";
import Navbar from "../../component/Navbar/Navbar";
import { ReactSVG } from "react-svg";
import microsoftIcon from "../../Asset/microsoft icon.svg";
import playStore from "../../Asset/paly store.svg";
import downloadAnimation from "../../Asset/download animation.png";
import IconMarquee from "../../component/marquee/Marquee";
import DownloadBanner from "./downloadBanner";
import DownloadVideoSection from "./downloadVideoSection";
import Feature from "./feature";
import { ShinyText } from "../Home/Home";
import Footer from "../../component/Footer/Footer";
import ContactUs from "../../component/contact-Us/ContactUs";
import { trackEvent } from "../../lib/mixpanel";

const Download = () => {
  const [isOpen, setIsOpen] = useState(false);
  const trackInstallClick = (platform) => {
    trackEvent("app_installed", {
      source_page: "download",
      platform,
    });
  };

  return (
    <>
      <div className="bg-white  flex flex-col gap-20 max-w-screen-2xl mx-auto overflow-hidden ">
        <Navbar />
        <div className=" flex flex-col xl:gap-20 lg:gap-16 gap-12  md:pt-36 pt-20 mt-6 md:mt-0 pb-16 z-10 relative ">
          <div className=" flex md:flex-row flex-col items-center md:gap-3 gap-10 md:mx-[5%] mx-[2%]">
            <div className="flex-1 flex md:items-start items-center justify-center flex-col gap-5 ">
              <span className="text-sm font-inter font-semibold flex justify-start items-center rounded-full  bg-[#EBF7FE] w-max  py-3 px-6">
                <span className="bg-gradient-to-r from-[#5ECCFF] to-[#407BFF] bg-clip-text text-transparent">
                  Zero Effort, Full Speed.
                </span>
              </span>
              <h1 className="xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] md:text-left text-center font-jakarta font-bold leading-tight ">
                Grab Zero Typing for <ShinyText text="Android and Windows " />
                today.
              </h1>
              <p className="xl:text-[1.438rem] lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] md:text-left text-center font-inter font-medium text-[#636363]">
                Experience unmatched speed and accuracy in voice{" "}
                <br className="lg:flex hidden" /> dictation. Now on Windows and
                Android.
              </p>
              <div className=" flex items-center gap-3 font-inter">
                <a
                  href="https://zerotyping.ai/ztaupdate/ZeroTypingAI.msi"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block"
                  onClick={() => trackInstallClick("windows")}
                >
                  <button className=" flex items-center justify-center gap-2 border-[1.5px] border-[#A6A6A6] bg-black text-white py-2 px-4 rounded-lg">
                    <ReactSVG
                      src={microsoftIcon}
                      beforeInjection={(svg) => {
                        svg.setAttribute("class", "w-[2rem] h-[2rem]");
                      }}
                    />
                    <div className=" flex flex-col items-start">
                      <span className=" text-[.6rem]">Download for</span>
                      <span className=" font-semibold">Windows</span>
                    </div>
                  </button>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=ai.zerotyping"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block"
                  onClick={() => trackInstallClick("android")}
                >
                  <button className=" flex items-center justify-center gap-2 border-[1.5px] border-[#A6A6A6] bg-black text-white py-2 px-4 rounded-lg">
                    <ReactSVG
                      src={playStore}
                      beforeInjection={(svg) => {
                        svg.setAttribute("class", "w-[2rem] h-[2rem]");
                      }}
                    />
                    <div className=" flex flex-col items-start">
                      <span className=" text-[.6rem]">GET IT ON</span>
                      <span className=" font-semibold">Google Play</span>
                    </div>
                  </button>
                </a>
              </div>
            </div>

            <div className="flex-1 relative flex justify-end ">
              <div className=" lg:w-[85%] md:w-[90%] w-full xl:rounded-3xl rounded-2xl shadow-none overflow-hidden">
                <video
                  className=" w-full scale-105 "
                  src="https://pub-25f4599302a64a3dab9e149b2b5f9a0f.r2.dev/videos/Download%20Page%20Animation1(1).mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  webkit-playsinline="true"
                  preload="metadata"
                />
              </div>
            </div>
          </div>
          <IconMarquee text="Connect with Any App You Love" />
          <DownloadBanner setIsOpen={setIsOpen} />
          <DownloadVideoSection />
          <Feature />
        </div>
      </div>
      <Footer />
      <ContactUs isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default Download;
